import Button from '../Button'

const UserCard = () => (
    <div>
        <h2>User Name</h2>
        <Button>Selecionar usuário</Button>
    </div>
)

export default UserCard